

<ng-container *ngrxLet="building$ as building">
    <div class="d-flex flex-row justify-content-between">
        <div class="d-flex flex-row" style="font-size:34px;">
            <div class="mb-auto">
                Test(s) - {{stage}} -
            </div>
            <div class="pl-2 d-flex flex-column">
                <div>{{buildingId}}</div>
                <div class="text-secondary font-italic" style="font-size:11px; margin-top:-9px;">
                    {{building.commonName}}
                </div>
            </div>
        </div>    
        <div class="small btn-group px-1 text-nowrap" dropdown [align]="'right'">
            <a id="table-detail-btn" href="javascript:false;" behavior="button" dropdownToggle 
                class="dropdown-toggle">
              Show/Hide <span class="caret"></span>
            </a>
            <ul style="z-index:9999;min-width:3rem;"
                id="dropdown-table-detail-options" *dropdownMenu class="dropdown-menu" 
                role="menu" aria-labelledby="table-detail-btn">
                <li role="button" class="px-2"
                    (click)="visibleColumns.callCounts=!visibleColumns.callCounts">
                  <i class="far" [ngClass]="visibleColumns.callCounts?'fa-check-square':'fa-square'"></i> Call Counts
                </li>
                <li role="button" class="px-2"
                    (click)="visibleColumns.comments=!visibleColumns.comments">
                  <i class="far" [ngClass]="visibleColumns.comments?'fa-check-square':'fa-square'"></i> Comments
                </li>
                <li role="button" class="px-2"
                    (click)="visibleColumns.environment=!visibleColumns.environment">
                  <i class="far" [ngClass]="visibleColumns.environment?'fa-check-square':'fa-square'"></i> Environment
                </li>
                <li role="button" class="px-2"
                    (click)="visibleColumns.time=!visibleColumns.time">
                  <i class="far" [ngClass]="visibleColumns.time?'fa-check-square':'fa-square'"></i> Time
                </li>
                <li role="button" class="px-2"
                    (click)="visibleColumns.seqStatus=!visibleColumns.seqStatus">
                  <i class="far" [ngClass]="visibleColumns.seqStatus?'fa-check-square':'fa-square'"></i> Sequence Status
                </li>
            </ul>
          </div>
    </div>
    <hr>
    <ng-container *ngIf="this.bTabActive">
    <i class="fa fa-spinner fa-spin" *ngIf="!initialRowsLoaded"></i>
    <ng-container *ngrxLet="pathTestRows$ as pathTestRows;">
        <div *ngIf="errorMsg" class="alert alert-danger">{{errorMsg}}</div>
        <div *ngIf="!pathTestRows?.length" class="alert alert-warning">No results for {{stage||''}} {{buildingId||''}}</div>
        <div *ngFor="let row of pathTestRows|orderBy:['pathId','cycle']" class="my-3 p-1 card">
            <div class="d-flex flex-row mx-1">
                <div style="font-size:26px;" class="text-primary d-flex flex-row" (click)="showTestPath(row.doc)"
                    role="button">
                    Test {{row.pathId}}&nbsp;-&nbsp;
                    <div class="d-flex flex-column">
                        <div>{{row.cycle|number:'2.0'}}</div>
                        <div class="text-secondary font-italic" style="font-size:10px;margin-top:-8px;">
                            cycle
                        </div>
                    </div>                                        
                </div>
                <div class="btn-group p-2 my-auto text-nowrap" dropdown>
                    <a id="edit-options-btn" href="javascript:false;" behavior="button" dropdownToggle class="dropdown-toggle">
                        <span class="caret"></span>
                    </a>
                    <ul style="z-index:9999;min-width:3rem;" *dropdownMenu class="p-1 dropdown-menu" 
                        role="menu" aria-labelledby="edit-options-btn">
                        <li role="menuitem" style="margin-bottom:2px;">
                            <button class="btn btn-secondary w-100 text-left" style="border-radius:0;"
                              [disabled]="!roleMgr.canEditPointTests" (click)="onOpenPathEditDlg(row.doc)">
                                <i class="fa fa-edit mr-1"></i>
                                Edit
                            </button>
                        </li>
                        <li role="menuitem">
                          <button class="btn btn-danger w-100 text-left" style="border-radius:0;"
                              [disabled]="!roleMgr.canEditPointTests" (click)="onDeletePathTest(row.doc)">
                              <i class="fa fa-trash mr-1"></i>
                            Delete
                          </button>
                        </li>
                    </ul>
                  </div>

            </div>
            <app-path-test-point-list
                [pathTest]="row.doc"
                [testPoints]="row.testPoints || []"
                [editFn]="null"
                [visibleColumns]="visibleColumns">
            </app-path-test-point-list>
        </div>
    </ng-container>
</ng-container>
</ng-container>